import { LEGAL_EXTENSIONS } from '@flows/configs/legal/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const legal_criminal = (params: StepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.criminal.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: `product_keys.${LEGAL_EXTENSIONS.criminalProductKey}`,
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.criminal.info.text',
        },
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.criminal.info.title',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_coverage_options',
  }) as const satisfies AnyStepConfiguration

export default legal_criminal
